import React from "react";

const HardwareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 173"
    fill="#ffff"
    stroke="ffff"
    {...props}
  >
    <path d="M128.253,56.864c15.186,0,27.432-12.247,27.432-27.432S143.536,2,128.253,2 
      c-15.186,0-27.432,12.247-27.432,27.432C100.918,44.716,113.165,56.864,128.253,56.864z 
      M64.571,136.32h-49.28 c-15.969,0-16.851-24.395,0.294-24.395H58.3l24.493-36.054
      c7.25-9.895,15.48-14.598,27.138-14.598h36.544c11.659,0,19.888,4.311,27.138,14.598
      l24.591,36.054h43.01c17.243,0,16.165,24.395,0.588,24.395h-49.28
      c-3.919,0-8.622-1.372-11.365-5.584l-18.811-26.844l-0.098,67.209H94.844
      l-0.098-67.209l-18.811,26.844C73.192,134.85,68.49,136.32,64.571,136.32z"/>
    <path d="M38.201,87.46h18.743c1.631,0,3.056-1.289,3.056-2.919V50.219c0-1.654-1.444-3.243-3.075-3.243H5.099 
      C3.468,46.977,2,48.588,2,50.219V84.54c0,1.631,1.468,2.919,3.099,2.919h18.7v5.06h-4.733c0.016,0.012,0.062,0.023,0.062,0.027
      v3.219c0,0-0.09,0.257-0.062,0.257h23.807V92.52h-4.671V87.46z 
      M6.671,80.842V52.037h49.047v28.805H6.671z"/>
    <path d="M244.996,86.824c-1.536-1.394-3.332-2.032-5.436-1.962c-0.709,0-1.394,0.165-2.103,0.402l-10.54-9.642 
      l6.783-8.012l10.777,9.501L254,66.263l-26.966-23.728l-9.524,10.848l10.493,9.241l-7.019,7.586l-9.595-8.792 
      c0.165-0.709,0.236-1.394,0.165-2.103c-0.071-2.103-0.898-3.9-2.434-5.27c-1.536-1.394-3.332-2.032-5.436-1.962 
      c-0.709,0-1.465,0.165-2.103,0.402l6.097,5.53l-5.388,5.908l-6.097-5.53c-0.165,0.709-0.236,1.465-0.165,2.103 
      c0.071,2.103,0.898,3.805,2.434,5.199c1.536,1.394,3.332,2.032,5.436,1.962c0.709,0,1.536-0.165,2.269-0.496l9.312,8.532 
      l-15.409,15.976c-1.064,0.898-1.607,2.174-1.607,3.569c0,2.6,2.103,4.703,4.703,4.703c1.607,0,3.001-0.827,3.9-2.032 
      l14.842-16.354l8.768,8.012l1.465,1.394c-0.165,0.709-0.236,1.536-0.236,2.269c0.071,2.103,0.898,3.805,2.434,5.27 
      c1.536,1.394,3.332,2.032,5.436,1.962c0.709,0,1.394-0.165,2.103-0.402l-6.097-5.53l5.436-5.932l6.027,5.554 
      c0.165-0.709,0.236-1.465,0.165-2.103C247.359,89.896,246.532,88.194,244.996,86.824z"/>
  </svg>
);

export default HardwareIcon;
